/**************************************************
 * Nombre:       Tarjeta_Categoria_Desplegable
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Collapse, Grid, Typography} from "@mui/material";
import {useContext, useEffect, useState} from "react";
import {contexApp} from "../../App";
import {useNavigate} from "react-router";

const Tarjeta_Categoria_Desplegable = ({it}) => {
    const cData = useContext(contexApp)
    const navigate = useNavigate();
    const [open, setOpen] = useState(false);
    const [subCategorias, setSubCategorias] = useState([])

    const irSubCategorias = (e, i) => {
        e.stopPropagation()
        navigate('/Resultados/subCat/' + i.nombre)
    }

    useEffect(() => {

        let subCats = cData.subCategorias

        let arr = subCats.filter((e) => e.categoria === it)
        setSubCategorias(arr)

    }, [cData]);
    return (
        <Grid container size={{xs: 12, sm: 12, md: 12}}


              sx={{justifyContent: 'flex-start', mt: 0.5, width: 50}}>
            <Typography
                onClick={() => navigate('/DetalleCat/' + it.toUpperCase())}
                onMouseEnter={() => setOpen(true)}
                onMouseLeave={() => setOpen(false)}

                sx={{
                    transition: 'all .3s ease-in-out',
                    color: '#000',
                    borderBottom: 1,
                    borderColor: '#ffffff00',
                    '&:hover': {
                        borderColor: '#000',
                    },
                    width: '100%',
                    px: 2,

                }}>{it}


                <Collapse in={open} timeout="auto" unmountOnExit
                          sx={{
                              position: 'absolute', mt: -4.5, ml: 15,
                              boxShadow: 4
                          }}
                >
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                        sx={{backgroundColor: '#fff', px: 2, py: 1, maxWidth: 150, borderRadius: 1}}
                    >


                        {subCategorias.map((item) => {
                            return (
                                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                                    <Typography
                                        onClick={(e) => irSubCategorias(e, item)}
                                        sx={{
                                            transition: 'all .3s ease-in-out',
                                            color: '#000',
                                            fontSize: 16,
                                            cursor: 'pointer',
                                            borderBottom: 1,
                                            fontWeight: 400,
                                            borderColor: '#ffffff00',
                                            mt: 1,
                                            '&:hover': {
                                                borderColor: '#000',
                                            }
                                        }}
                                    >{item.nombre}</Typography>
                                </Grid>
                            )
                        })}

                    </Grid>
                </Collapse>


            </Typography>
        </Grid>
    )

}
export default Tarjeta_Categoria_Desplegable